var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{attrs:{"zoom":"10"}},[_c('base-map',{attrs:{"url":_vm.url}}),_c('a-q-i-report')],1)}
var staticRenderFns = []

export { render, staticRenderFns }